import { SpherePlatformApp } from '@sphere/platform';
import { instantAnalystApp } from './instant-analyst';
import { PATHS } from 'instant-analyst-shared';

export const InstantAnalystApp: SpherePlatformApp = {
    APP: instantAnalystApp,
    PATHS
};
